<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:body>
        <b-row>
          <!-- View Only -->
          <b-col v-if="editAttendanceDetails" sm="12" md="12" lg="12">
            <b-table-simple striped bordered small hover>
              <tbody>
                <b-tr>
                  <b-td>{{ $t('globalTrans.organization') }}</b-td>
                  <b-td colspan="3">{{ (currentLocale === 'en') ? editAttendanceDetails.org_name : editAttendanceDetails.org_name_bn }}</b-td>
                </b-tr>
                <b-tr>
                  <b-td>{{ $t('child_configuration.institute_type') }}</b-td>
                  <b-td colspan="3">{{ getInstituteTypeName(editAttendanceDetails.office_type_id) }}</b-td>
                </b-tr>
                <b-tr>
                  <b-td>{{ $t('child_configuration.institute_name') }}</b-td>
                  <b-td colspan="3">{{ (currentLocale === 'en') ? editAttendanceDetails.institute_name : editAttendanceDetails.institute_name_bn }}</b-td>
                </b-tr>
                <b-tr>
                  <b-td>{{ $t('educational_management.class') }}</b-td>
                  <b-td colspan="3">{{ (currentLocale === 'en') ? editAttendanceDetails.class_name : editAttendanceDetails.class_name_bn }}</b-td>
                </b-tr>
                <b-tr>
                  <b-td>{{ $t('institute_manangement.attendance_date') }}</b-td>
                  <b-td colspan="3">{{ editAttendanceDetails.attendance_date | dateFormat }}</b-td>
                </b-tr>
              </tbody>
            </b-table-simple>
          </b-col>

          <!-- Form -->
          <b-col sm="12" md="12" lg="12">
            <ValidationObserver ref="form1"  v-slot="{ handleSubmit, reset }">
              <b-form v-if="!inEditMode" @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset" enctype="multipart/form-data">
                <b-row>
                    <b-col sm="12" md="6" lg="6">
                      <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                          <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="organization_id"
                            slot-scope="{ valid, errors }"
                          >
                            <template v-slot:label>
                              {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="search.org_id"
                              :options="orgList"
                              id="organization_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                              <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                                {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="6" lg="6">
                      <ValidationProvider name="Institute Type" vid="office_type_id" rules="required|min_value:1">
                          <b-form-group
                            class="row"
                            label-cols-sm="4"
                            :label="$t('child_configuration.institute_type')"
                            label-for="office_type_id"
                            slot-scope="{ valid, errors }"
                          >
                            <template v-slot:label>
                              {{$t('child_configuration.institute_type')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="search.office_type_id"
                              :options="officeTypeList"
                              id="office_type_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                              <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                                {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <b-col sm="12" md="6" lg="6">
                      <ValidationProvider name="Institute Name" vid="office_id" rules="required|min_value:1">
                          <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="office_id"
                            slot-scope="{ valid, errors }"
                          >
                            <template v-slot:label>
                              {{$t('child_configuration.institute_name')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="search.office_id"
                              :options="officeList"
                              id="office_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                              <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                                {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="6" lg="6">
                      <ValidationProvider name="Class Name" vid="class_id" rules="required|min_value:1">
                          <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="class_id"
                            slot-scope="{ valid, errors }"
                          >
                            <template v-slot:label>
                              {{$t('child_admission_management.class')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="search.class_id"
                              :options="classList"
                              id="class_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                              <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                                {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <b-col sm="12" md="6" lg="6">
                      <ValidationProvider name="Student Roll">
                        <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="student_id"
                        >
                            <template v-slot:label>
                                {{$t('admission_management.student_roll')}}
                            </template>
                            <b-form-input
                                v-model="search.student_id"
                                id="student_id"
                            >
                            </b-form-input>
                        </b-form-group>
                    </ValidationProvider>
                    </b-col>
                    <b-col>
                      <div class="text-right">
                        <b-button type="submit" variant="primary">{{ $t('globalTrans.search')}}</b-button>
                      </div>
                    </b-col>
                </b-row>
              </b-form>
            </ValidationObserver>
            <hr>
            <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                <b-form @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" enctype="multipart/form-data">
                  <b-overlay :show="formLoader">
                    <b-row>
                      <b-col xl="12" lg="12" sm="12">
                        <b-table-simple bordered>
                          <thead class="text-white bg-primary">
                              <tr>
                                <th class="text-center" width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                <th scope="col">{{ $t('educational_management.student_name') }}</th>
                                <th scope="col">{{ $t('admission_management.student_roll') }}</th>
                                <th class="text-center" scope="col">{{ $t('institute_manangement.attendance') }}</th>
                              </tr>
                          </thead>
                          <b-tbody>
                              <b-tr v-for="(item, index) in attendance.list" :key="index">
                                  <b-td class="text-center">{{ $n(index + 1) }}</b-td>
                                  <b-td>{{ (currentLocale === 'en') ? item.text_en : item.text_bn }}</b-td>
                                  <b-td>{{ $n(item.student_id, { useGrouping: false}) }}</b-td>
                                  <b-td>
                                    <b-form-group
                                      style="margin-bottom: 0rem"
                                      class="text-center"
                                    >
                                      <b-form-checkbox
                                          :id="'is_same-' + index"
                                          v-model="item.checked"
                                          name="checkbox-1"
                                          value="1"
                                          unchecked-value="0"
                                      >
                                      </b-form-checkbox>
                                    </b-form-group>
                                  </b-td>
                              </b-tr>
                              <b-tr v-if="attendance.list.length === 0">
                                  <td colspan="5" class="text-center">
                                    <span class="text-black">{{ $t('globalTrans.noDataFound') }}</span>
                                  </td>
                              </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col v-if="!inEditMode" sm="8" md="8" lg="8">
                        <ValidationProvider name="Attendance Date" vid="attendance_date" rules="required">
                          <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="attendance_date"
                            slot-scope="{ valid, errors }"
                          >
                            <template v-slot:label>
                              {{$t('institute_manangement.attendance_date')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                              class="form-control"
                              v-model="attendance.attendance_date"
                              placeholder="Select Date"
                              id="attendance_date"
                              :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" md="12" lg="12">
                        <div class="col text-right">
                        <b-button type="submit" variant="primary" class="mr-2" :disabled="attendance.list.length <= 0">
                          {{ saveBtnName }}
                        </b-button>
                        <b-button type="button" variant="danger" class="mr-2" @click="$bvModal.hide('modal-4')">
                          {{ $t('globalTrans.cancel') }}
                        </b-button>
                      </div>
                      </b-col>
                    </b-row>
                  </b-overlay>
                </b-form>
            </ValidationObserver>
          </b-col>
        </b-row>
      </template>
    </iq-card>
  </b-container>
</template>
<script>

import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { classAttendanceStudentInfoApi, classAttendanceStudentAttendanceInfoApi, classAttendanceStoreApi, classAttendanceUpdateApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created () {
    this.search.org_id = this.$store.state.dataFilters.orgId
    this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
    this.search.office_id = this.$store.state.dataFilters.officeId
    if (this.id) {
      const attendance = this.getDataFromStore()
      if (!attendance) return
      /** In Edit Mode */
      this.inEditMode = true
      this.editAttendanceDetails = attendance
      this.search.org_id = attendance.org_id
      this.search.office_type_id = attendance.office_type_id
      this.search.office_id = attendance.office_id
      this.search.class_id = attendance.class_id
      this.attendance.attendance_date = attendance.attendance_date
      this.searchData()
    }
  },
  mounted () {
    flatpickr('#attendance_date', {})
  },
  data () {
    return {
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      search: {
        org_id: 0,
        office_type_id: 0,
        office_id: 0,
        class_id: 0,
        student_id: ''
      },
      attendance: {
        attendance_date: '',
        list: []
      },
      inEditMode: false,
      editAttendanceDetails: null,
      formLoader: false,
      officeTypeList: [],
      officeList: []
    }
  },
  computed: {
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    classList: function () {
      const list = this.$store.state.DisabilitySchoolService.commonObj.classList.filter(item => item.status === 1)
      return list.map(obj => {
        if (this.currentLocale === 'en') {
          return { value: obj.value, text: obj.text_en }
        } else {
          return { value: obj.value, text: obj.text_bn }
        }
      })
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    'search.org_id': function (newVal, oldVal) {
      if (newVal > 0) {
        this.getOfficeTypeList()
      } else {
        this.officeTypeList = []
      }
    },
    'search.office_type_id': function (newVal, oldVal) {
      if (newVal > 0) {
        this.getOfficeList()
      } else {
        this.officeList = []
      }
    },
    'search.office_id': function (newVal, oldVal) {
      if (newVal > 0) {
        this.getClassList()
      } else {
        this.classList = []
      }
      this.search.class_id = 0
    },
    currentLocale: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.search.org_id) this.getOfficeTypeList()
        if (this.search.office_type_id) this.getOfficeList()
        if (this.search.office_id) this.getClassList()
      }
    }
  },
  methods: {
    getDataFromStore () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return tmpData !== undefined ? JSON.parse(JSON.stringify(tmpData)) : null
    },
    getOfficeTypeList () {
      const list = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id)
      this.officeTypeList = list.map(obj => {
        if (this.currentLocale === 'en') {
          return { value: obj.value, text: obj.text_en }
        } else {
          return { value: obj.value, text: obj.text_bn }
        }
      })
    },
    getOfficeList () {
      const list = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id)
      this.officeList = list.map(obj => {
        if (this.currentLocale === 'en') {
          return { value: obj.value, text: obj.text_en }
        } else {
          return { value: obj.value, text: obj.text_bn }
        }
      })
    },
    getInstituteTypeName (id) {
      const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === id)
      if (this.$i18n.locale === 'bn') {
        return tmpData.text_bn
      } else {
         return tmpData.text_en
      }
    },
    getRelationalData (data) {
      if (this.inEditMode && this.id) {
        return data.map(item => {
          return item.class_attendance_id ? Object.assign({}, item, { checked: '1' }) : Object.assign({}, item, { checked: '0' })
        })
      } else {
        return data.map(item => {
          return Object.assign({}, item, { checked: '1' })
        })
      }
    },
    /**
     * Asynchronous
     */
    async searchData () {
      this.formLoader = true
      let result = null

      /** Search */
      if (this.inEditMode && this.id) {
        result = await RestApi.getData(disabilitySchoolServiceBaseUrl, classAttendanceStudentAttendanceInfoApi, { attendance_date: this.attendance.attendance_date, ...this.search })
      } else {
        result = await RestApi.getData(disabilitySchoolServiceBaseUrl, classAttendanceStudentInfoApi, this.search)
      }

      if (result.success && result.data) {
        this.attendance.list = this.getRelationalData(result.data)
      } else {
        this.attendance.list = []
      }

      this.formLoader = false
    },
    async saveData () {
      this.formLoader = true
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      let result = null

      /** Save */
      if (this.inEditMode && this.id) {
        result = await RestApi.putData(disabilitySchoolServiceBaseUrl, `${classAttendanceUpdateApi}/${this.id}`, { ...this.attendance, ...this.editAttendanceDetails })
      } else {
        result = await RestApi.postData(disabilitySchoolServiceBaseUrl, classAttendanceStoreApi, { ...this.attendance, ...this.search })
      }

      if (result.success) {
        this.formLoader = false
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: true })
        this.$bvModal.hide('modal-4')

        this.$toast.success({
          title: this.$t('globalTrans.success'),
          message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
          color: '#D6E09B'
        })
      } else {
        this.formLoader = false
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
        if (result.errors) this.$refs.form.setErrors(result.errors)

        this.$toast.error({
            title: this.$t('globalTrans.error'),
            message: result.message,
            color: '#D6E09B'
        })
      }
    }
    /** EMD */
  }
}
</script>
